import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import Logger from 'core/utils/Logger'
import { ISobCompetitor } from 'partner360/models/ISobCompetitor'

export interface IApplySobCompetitorsChangesParameters {
  fYear: number
  partnerId: string
  programType: ProgramTypes
  competitors: ISobCompetitor[]
}

export interface IApplySobCompetitorsChangesResponse {
  data: ISobCompetitor[]
  programType: ProgramTypes
}

export const applySobCompetitorsChanges = async ({
  fYear,
  partnerId,
  programType,
  competitors,
}: IApplySobCompetitorsChangesParameters): Promise<IApplySobCompetitorsChangesResponse> => {
  const url = proxy(`/webservice/197/sp/v4/spJBPApplyChangesSobCompetitors/call`)

  if (fYear && partnerId && programType) {
    const payload = {
      'p.Fyear': fYear,
      'p.PartnerID': partnerId,
      'p.Offering': programType,
      'p.SobCompetitors': JSON.stringify(competitors),
    }

    const {
      app: { ownerId },
    } = appGetState()

    const [accessToken] = getTokens(ownerId)
    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }

    try {
      const response = await Rest.post({ url, payload, headers })
      return { data: response.Data, programType }
    } catch (e) {
      Logger.error(e)
      return { data: [], programType }
    }
  }

  return { data: [], programType }
}
